import React, { Component } from 'react';
import { ReactComponent as NewBack } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Back } from '../../../assets/svg/back-icon-new.svg';
import { ReactComponent as Down } from '../../../assets/svg/down-arrow-search.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import { ReactComponent as Minus } from '../../../assets/svg/minus-circle.svg';
import { ReactComponent as RegisterIcon } from '../../../assets/svg/hd-reg.svg';
import { ReactComponent as CopyIcon } from '../../../assets/svg/data-copied.svg';
import { ReactComponent as AssignIcon } from '../../../assets/svg/hd-assign.svg';
import { ReactComponent as ReceiveIcon } from '../../../assets/svg/hd-received.svg';
import { ReactComponent as LocationIcon } from '../../../assets/svg/location-update.svg';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import { getApolloContext, gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import DataTableCompact from '../../components/DataTableCompact';
import Tree2 from '../../components/tree2';
import { ReactComponent as Search } from '../../../assets/svg/search-img.svg';
import _ from 'lodash';
import Select, { components } from 'react-select';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
class HardDriveScanDetails extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			dummyJson: {
				_id: '642c3182c79e2713f58fd38f',

				qrCode: 'Z7C6738D',
				hddName: 'SHREYA YESHWANTH WORKING',
				referenceS3Key: 'SHREYA YESHWANTH WORKING_2023-04-04T14-17-17.023Z.csv',
				createdOn: {
					$date: '1970-01-01T00:00:00.000Z',
				},
				folders: [
					{
						path: 'Galleries/ Bride pasupu/shreya+yashwanth bride pasupu decors',
						totalFiles: 11,
						details: [
							{
								fileext: '.jpg',
								files: 11,
								cumulativeSize: 104627616,
							},
						],
						cumulativeSize: 104627616,
					},
					{
						path: 'Galleries/ Bride pasupu/shreya+yashwanth bride pasupu docc',
						totalFiles: 51,
						details: [
							{
								fileext: '.jpg',
								files: 51,
								cumulativeSize: 501774453,
							},
						],
						cumulativeSize: 501774453,
					},
					{
						path: 'Galleries/ Bride pasupu/shreya+yashwanth bride pasupu potraits',
						totalFiles: 63,
						details: [
							{
								fileext: '.jpg',
								files: 63,
								cumulativeSize: 606049441,
							},
						],
						cumulativeSize: 606049441,
					},
					{
						path: 'Galleries/ Groom deeparadhana',
						totalFiles: 66,
						details: [
							{
								fileext: '.jpg',
								files: 66,
								cumulativeSize: 169757657,
							},
						],
						cumulativeSize: 169757657,
					},
					{
						path: 'Galleries/Bride deeparadhana/shreya+yashwanth BD decc',
						totalFiles: 5,
						details: [
							{
								fileext: '.jpg',
								files: 5,
								cumulativeSize: 16909574,
							},
						],
						cumulativeSize: 16909574,
					},
					{
						path: 'Galleries/Bride deeparadhana/shreya+yashwanth BD DOCC',
						totalFiles: 70,
						details: [
							{
								fileext: '.jpg',
								files: 70,
								cumulativeSize: 169148036,
							},
						],
						cumulativeSize: 169148036,
					},
					{
						path: 'Galleries/Coupleshoot',
						totalFiles: 62,
						details: [
							{
								fileext: '.jpg',
								files: 62,
								cumulativeSize: 550966201,
							},
						],
						cumulativeSize: 550966201,
					},

					{
						path: 'Galleries/Engagement/All-5',
						totalFiles: 25,
						details: [
							{
								fileext: '.jpg',
								files: 25,
								cumulativeSize: 525805187,
							},
						],
						cumulativeSize: 525805187,
					},
					{
						path: 'Galleries/Groom pasupu',
						totalFiles: 180,
						details: [
							{
								fileext: '.jpg',
								files: 180,
								cumulativeSize: 1363003187,
							},
						],
						cumulativeSize: 1363003187,
					},
					{
						path: 'Galleries/Mehendi/Decor',
						totalFiles: 51,
						details: [
							{
								fileext: '.jpg',
								files: 51,
								cumulativeSize: 184465638,
							},
						],
						cumulativeSize: 184465638,
					},
					{
						path: 'Galleries/Mehendi/Doccumentary',
						totalFiles: 239,
						details: [
							{
								fileext: '.jpg',
								files: 239,
								cumulativeSize: 937088697,
							},
						],
						cumulativeSize: 937088697,
					},
					{
						path: 'Galleries/Mehendi/Potraits',
						totalFiles: 121,
						details: [
							{
								fileext: '.jpg',
								files: 121,
								cumulativeSize: 662147976,
							},
						],
						cumulativeSize: 662147976,
					},
					{
						path: 'Galleries/Pellikoduku haldi/pppp',
						totalFiles: 30,
						details: [
							{
								fileext: '.jpg',
								files: 30,
								cumulativeSize: 94458011,
							},
						],
						cumulativeSize: 94458011,
					},
					{
						path: 'Galleries/Pellikoduku haldi/shreya+yashwanth pellikoduku haldi dec',
						totalFiles: 24,
						details: [
							{
								fileext: '.jpg',
								files: 24,
								cumulativeSize: 89762621,
							},
						],
						cumulativeSize: 89762621,
					},
					{
						path: 'Galleries/Pellikoduku haldi/shreya+yashwanth pellikoduku haldi docc',
						totalFiles: 325,
						details: [
							{
								fileext: '.jpg',
								files: 325,
								cumulativeSize: 1090993012,
							},
						],
						cumulativeSize: 1090993012,
					},
					{
						path: 'Galleries/Pellikoduku haldi/shreya+yashwanth pellikoduku haldi potraits',
						totalFiles: 30,
						details: [
							{
								fileext: '.jpg',
								files: 30,
								cumulativeSize: 94407118,
							},
						],
						cumulativeSize: 94407118,
					},
					{
						path: 'Galleries/Pellikoduku/ppp',
						totalFiles: 18,
						details: [
							{
								fileext: '.jpg',
								files: 18,
								cumulativeSize: 35064042,
							},
						],
						cumulativeSize: 35064042,
					},
					{
						path: 'Galleries/Pellikoduku/shreya+yashwanth pellikoduku decc',
						totalFiles: 12,
						details: [
							{
								fileext: '.jpg',
								files: 12,
								cumulativeSize: 39425470,
							},
						],
						cumulativeSize: 39425470,
					},
					{
						path: 'Galleries/Pellikoduku/shreya+yashwanth pellikoduku docc',
						totalFiles: 129,
						details: [
							{
								fileext: '.jpg',
								files: 129,
								cumulativeSize: 355621963,
							},
						],
						cumulativeSize: 355621963,
					},
					{
						path: 'Galleries/Pellikoduku/shreya+yashwanth pellikoduku potraits',
						totalFiles: 18,
						details: [
							{
								fileext: '.jpg',
								files: 18,
								cumulativeSize: 34582363,
							},
						],
						cumulativeSize: 34582363,
					},
					{
						path: 'Galleries/Pellikuthuru/shreya+yashwanth pellikuthuru decc',
						totalFiles: 37,
						details: [
							{
								fileext: '.jpg',
								files: 37,
								cumulativeSize: 186219372,
							},
						],
						cumulativeSize: 186219372,
					},
					{
						path: 'Galleries/Pellikuthuru/shreya+yashwanth pellikuthuru docc',
						totalFiles: 294,
						details: [
							{
								fileext: '.jpg',
								files: 294,
								cumulativeSize: 1258346275,
							},
						],
						cumulativeSize: 1258346275,
					},
					{
						path: 'Galleries/Pellikuthuru/shreya+yashwanth pellikuthuru potraits',
						totalFiles: 49,
						details: [
							{
								fileext: '.jpg',
								files: 49,
								cumulativeSize: 209130091,
							},
						],
						cumulativeSize: 209130091,
					},
					{
						path: 'Galleries/Sangeeth/shreya+yashwanth sangeeth decc',
						totalFiles: 44,
						details: [
							{
								fileext: '.jpg',
								files: 44,
								cumulativeSize: 186589474,
							},
						],
						cumulativeSize: 186589474,
					},
					{
						path: 'Galleries/Sangeeth/shreya+yashwanth sangeeth docc',
						totalFiles: 631,
						details: [
							{
								fileext: '.jpg',
								files: 631,
								cumulativeSize: 1810875712,
							},
						],
						cumulativeSize: 1810875712,
					},
					{
						path: 'Galleries/Sangeeth/shreya+yashwanth sangeeth potraits',
						totalFiles: 70,
						details: [
							{
								fileext: '.jpg',
								files: 70,
								cumulativeSize: 229230108,
							},
						],
						cumulativeSize: 229230108,
					},
					{
						path: 'Galleries/Vratham',
						totalFiles: 3,
						details: [
							{
								fileext: '.nef',
								files: 3,
								cumulativeSize: 113044524,
							},
						],
						cumulativeSize: 113044524,
					},
					{
						path: 'Galleries/Vratham/shreya vratham decc',
						totalFiles: 14,
						details: [
							{
								fileext: '.jpg',
								files: 14,
								cumulativeSize: 48735853,
							},
						],
						cumulativeSize: 48735853,
					},
					{
						path: 'Galleries/Vratham/shreya vratham docc',
						totalFiles: 98,
						details: [
							{
								fileext: '.jpg',
								files: 98,
								cumulativeSize: 292685106,
							},
						],
						cumulativeSize: 292685106,
					},
					{
						path: 'Galleries/Vratham/shreya vratham potraits',
						totalFiles: 14,
						details: [
							{
								fileext: '.jpg',
								files: 14,
								cumulativeSize: 41531917,
							},
						],
						cumulativeSize: 41531917,
					},

					{
						path: 'Galleries/Wedding/Decor',
						totalFiles: 21,
						details: [
							{
								fileext: '.jpg',
								files: 21,
								cumulativeSize: 203142520,
							},
						],
						cumulativeSize: 203142520,
					},

					{
						path: 'Galleries/Wedding/Highlights',
						totalFiles: 92,
						details: [
							{
								fileext: '.jpg',
								files: 92,
								cumulativeSize: 861725358,
							},
						],
						cumulativeSize: 861725358,
					},
					{
						path: 'Galleries/Wedding/potraits',
						totalFiles: 78,
						details: [
							{
								fileext: '.jpg',
								files: 78,
								cumulativeSize: 724654663,
							},
						],
						cumulativeSize: 724654663,
					},
					{
						path: 'Project File',
						totalFiles: 2,
						details: [
							{
								fileext: '.prproj',
								files: 1,
								cumulativeSize: 19026594,
							},
							{
								fileext: '.mp4',
								files: 1,
								cumulativeSize: 1294057590,
							},
						],
						cumulativeSize: 1313084184,
					},
					{
						path: 'Project File/Adobe Premiere Pro Auto-Save',
						totalFiles: 9,
						details: [
							{
								fileext: '.prproj',
								files: 9,
								cumulativeSize: 171040734,
							},
						],
						cumulativeSize: 171040734,
					},
					{
						path: 'Project File/shreya wed cat/shreya wed cat Helper.lrdata',
						totalFiles: 2,
						details: [
							{
								fileext: '.db',
								files: 2,
								cumulativeSize: 17809408,
							},
						],
						cumulativeSize: 17809408,
					},
					{
						path: 'Project File/shreya wed cat/shreya wed cat Previews.lrdata',
						totalFiles: 2,
						details: [
							{
								fileext: '.db',
								files: 2,
								cumulativeSize: 65282048,
							},
						],
						cumulativeSize: 65282048,
					},
					{
						path: 'Project File/shreya wed cat/shreya wed cat.lrcat-data',
						totalFiles: 26,
						details: [
							{
								fileext: '.blob',
								files: 4,
								cumulativeSize: 4828292,
							},
							{
								fileext: '.log',
								files: 3,
								cumulativeSize: 0,
							},
							{
								fileext: '.sst',
								files: 1,
								cumulativeSize: 2510,
							},
							{
								fileext: '',
								files: 7,
								cumulativeSize: 70085,
							},
							{
								fileext: '.1677322082097338',
								files: 1,
								cumulativeSize: 106904,
							},
							{
								fileext: '.1677325146682859',
								files: 1,
								cumulativeSize: 29588,
							},
							{
								fileext: '.1677478223230859',
								files: 1,
								cumulativeSize: 39957,
							},
							{
								fileext: '.1677492129681962',
								files: 1,
								cumulativeSize: 106643,
							},
							{
								fileext: '.1677493097239517',
								files: 1,
								cumulativeSize: 30026,
							},
							{
								fileext: '.1677501478609465',
								files: 1,
								cumulativeSize: 51352,
							},
							{
								fileext: '.1677503075870573',
								files: 1,
								cumulativeSize: 24255,
							},
							{
								fileext: '.1677508318649086',
								files: 1,
								cumulativeSize: 44841,
							},
							{
								fileext: '.1677509756851183',
								files: 1,
								cumulativeSize: 31306,
							},
							{
								fileext: '.1677564141845834',
								files: 1,
								cumulativeSize: 33755,
							},
							{
								fileext: '.1677566546332437',
								files: 1,
								cumulativeSize: 27790,
							},
						],
						cumulativeSize: 5427304,
					},
					{
						path: 'Project File/vratham cat/vratham cat Helper.lrdata',
						totalFiles: 2,
						details: [
							{
								fileext: '.db',
								files: 2,
								cumulativeSize: 3178496,
							},
						],
						cumulativeSize: 3178496,
					},
					{
						path: 'Project File/vratham cat/vratham cat Previews.lrdata',
						totalFiles: 2,
						details: [
							{
								fileext: '.db',
								files: 2,
								cumulativeSize: 15433728,
							},
						],
						cumulativeSize: 15433728,
					},
					{
						path: 'Project File/vratham cat/vratham cat.lrcat-data',
						totalFiles: 15,
						details: [
							{
								fileext: '.sst',
								files: 1,
								cumulativeSize: 2203,
							},
							{
								fileext: '.blob',
								files: 1,
								cumulativeSize: 9172438,
							},
							{
								fileext: '.log',
								files: 2,
								cumulativeSize: 191753,
							},
							{
								fileext: '',
								files: 7,
								cumulativeSize: 50402,
							},
							{
								fileext: '.1679294067235609',
								files: 1,
								cumulativeSize: 35058,
							},
							{
								fileext: '.1679296380446452',
								files: 1,
								cumulativeSize: 32583,
							},
							{
								fileext: '.1679302568572054',
								files: 1,
								cumulativeSize: 50650,
							},
							{
								fileext: '.1679306603199258',
								files: 1,
								cumulativeSize: 43963,
							},
						],
						cumulativeSize: 9579050,
					},

					{
						path: 'RAW DATA/BRIDE CEREMONY/PHOTOS',
						totalFiles: 3,
						details: [
							{
								fileext: '.png',
								files: 3,
								cumulativeSize: 5587582,
							},
						],
						cumulativeSize: 5587582,
					},

					{
						path: 'RAW DATA/BRIDE CEREMONY/VIDEOS',
						totalFiles: 2,
						details: [
							{
								fileext: '.png',
								files: 2,
								cumulativeSize: 3972742,
							},
						],
						cumulativeSize: 3972742,
					},

					{
						path: 'RAW DATA/BRIDE DEEPPARADHANA/PHOTOS',
						totalFiles: 1,
						details: [
							{
								fileext: '.png',
								files: 1,
								cumulativeSize: 2051996,
							},
						],
						cumulativeSize: 2051996,
					},

					{
						path: 'RAW DATA/COCKTAIL : SANGEETH/ VIDEOS',
						totalFiles: 3,
						details: [
							{
								fileext: '.png',
								files: 3,
								cumulativeSize: 8408351,
							},
						],
						cumulativeSize: 8408351,
					},

					{
						path: 'RAW DATA/COCKTAIL : SANGEETH/PHOTOS',
						totalFiles: 1,
						details: [
							{
								fileext: '.png',
								files: 1,
								cumulativeSize: 2192707,
							},
						],
						cumulativeSize: 2192707,
					},

					{
						path: 'RAW DATA/Groom Pasupu/Morning/VIDEOS',
						totalFiles: 3,
						details: [
							{
								fileext: '.png',
								files: 3,
								cumulativeSize: 20659033,
							},
						],
						cumulativeSize: 20659033,
					},

					{
						path: 'RAW DATA/PELLIKODUKU/PHOTOS',
						totalFiles: 2,
						details: [
							{
								fileext: '.png',
								files: 2,
								cumulativeSize: 4963800,
							},
						],
						cumulativeSize: 4963800,
					},

					{
						path: 'RAW DATA/PELLIKODUKU/VIDEOS',
						totalFiles: 1,
						details: [
							{
								fileext: '.png',
								files: 1,
								cumulativeSize: 2481947,
							},
						],
						cumulativeSize: 2481947,
					},

					{
						path: 'RAW DATA/VRATHAM/PHOTOS ',
						totalFiles: 1,
						details: [
							{
								fileext: '.png',
								files: 1,
								cumulativeSize: 3954673,
							},
						],
						cumulativeSize: 3954673,
					},

					{
						path: 'RAW DATA/VRATHAM/VIDEOS',
						totalFiles: 1,
						details: [
							{
								fileext: '.png',
								files: 1,
								cumulativeSize: 4130510,
							},
						],
						cumulativeSize: 4130510,
					},

					{
						path: 'RAW DATA/WEDDING/PHOTOS/ss',
						totalFiles: 10,
						details: [
							{
								fileext: '.png',
								files: 10,
								cumulativeSize: 56204331,
							},
						],
						cumulativeSize: 56204331,
					},
					{
						path: 'RAW DATA/WEDDING/VIDEOS',
						totalFiles: 5,
						details: [
							{
								fileext: '.png',
								files: 5,
								cumulativeSize: 15614000,
							},
						],
						cumulativeSize: 15614000,
					},

					{
						path: 'RAW DATA/WEDDING/VIDEOS/KEY4TWP4 (MICRO SD)/MISC/GIS',
						totalFiles: 1,
						details: [
							{
								fileext: '.gis',
								files: 1,
								cumulativeSize: 43156816,
							},
						],
						cumulativeSize: 43156816,
					},
					{
						path: 'RAW DATA/WEDDING/VIDEOS/KEY4TWP4 (MICRO SD)/MISC/THM/100',
						totalFiles: 593,
						details: [
							{
								fileext: '.ais',
								files: 211,
								cumulativeSize: 0,
							},
							{
								fileext: '.scr',
								files: 191,
								cumulativeSize: 34647704,
							},
							{
								fileext: '.thm',
								files: 191,
								cumulativeSize: 1710066,
							},
						],
						cumulativeSize: 36357770,
					},

					{
						path: 'Traditional Videos/Project files',
						totalFiles: 10,
						details: [
							{
								fileext: '.prproj',
								files: 10,
								cumulativeSize: 114472284,
							},
						],
						cumulativeSize: 114472284,
					},
				],
			},
			tenantUserId: null,
		};
	}
	componentDidMount = async () => {};
	goBack = (e) => {
		this.props.navigate(-1);
	};
	b2s = (t) => {
		let e = (Math.log2(t) / 10) | 0;
		return (t / 1024 ** (e = e <= 0 ? 0 : e)).toFixed(3) + 'BKMGP'[e];
	};
	pathToTree = (paths) => {
		const tree = {};
		for (let i = 0; i < paths.length; ++i) {
			const path = paths[i].path;
			const items = paths[i].totalFiles;
			// const sizeInGB = this.b2s(path[i].cumulativeSize);
			const sizeInGB = (paths[i].cumulativeSize / Math.pow(10, 9)).toFixed(3);

			const details = paths[i].details;
			const isVerified = true;

			if (path) {
				let node = tree;

				const parts = path.split(/[\\\/¥₩]+/i);

				for (let j = 0; j < parts.length; ++j) {
					const part = parts[j];
					if (part) {
						node =
							node[part] ??
							(node[part] =
								items && j == parts.length - 1
									? { path, items, sizeInGB, isVerified, details }
									: {});
					}
				}
			}
		}
		return tree;
	};
	render() {
		return (
			<div className="assign-receive-container ar-harddrive-logs-container">
				<div className="arc-header">
					<div className="back-btn" onClick={(e) => this.goBack(e)}>
						<Back style={{ width: '20px', height: '20px' }} />
					</div>
					<div className="arch-item">
						<span className="arch-item-span">
							<b className="arch-item-bold">Hard Drive</b>
							<p className="arch-item-p">
								{/* {this.props.params.qrcode} */}
								HDY01HDA23
							</p>
						</span>
					</div>
					<div className="next-btn">
						{' '}
						<NewBack style={{ width: '20px', height: '20px' }} />
					</div>
					<div className="arch-item">
						<span className="arch-item-span">
							<b className="arch-item-bold">Scan</b>
							<p className="arch-item-p">
								{/* {this.props.params.qrcode} */}
								12/01/23, 12:30 pm
							</p>
						</span>
					</div>
				</div>
				<div
					style={{
						padding: '30px',
						width: '40vw',
					}}
				>
					<table className="memoryCardSumaryTable4" style={{ width: '100%' }}>
						<tr>
							<th>DATE & TIME</th>
							<th>NO. OF FILES</th>
							<th>DATA SIZE</th>
							<th>NO. OF FOLDERS</th>
						</tr>
					</table>
				</div>
				<div className="pd-item-body horizontal-scroll-hdds">
					{/**HDD Item */}

					<div className="pd-hdd-item" style={{ padding: '30px' }}>
						<div className="pdhdditem-header"></div>

						<div className="pdhdditem-contents">
							<div className="hdd-tree-view" style={{ width: '42vw' }}>
								<Tree2
									data={
										this.state.dummyJson.folders !== null &&
										_.size(this.state.dummyJson.folders) > 0
											? this.pathToTree(this.state.dummyJson.folders)
											: []
									}
									contents={this.state.dummyJson.folders}
									hardDrive={this.state.dummyJson.qrCode}
									hardDriveID={this.state.dummyJson._id}
									// createdBy={this.state.tenantUserId}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default withRouter(HardDriveScanDetails);
